import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Button from '../../UI/Button/Button';
import PrimaryModal from '../../UI/Modal/PrimaryModal';
import Input from '../../UI/Input';
import { useUserContext } from '../../../contexts/UserContext';
import { createEpmTag } from '../../../utils/APIs';
import { EPM_LIMITS } from '../validation/epmRules';
import { tagSchema } from '../validation/epmSchemas';

const AddTagModal = ({ onClose, onSaved }) => {
    const { userData } = useUserContext();
    const [tag, setTag] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formatted = tag.trim().toLowerCase();

        try {
            tagSchema.validateSync(formatted);
        } catch (validationErr) {
            setError(validationErr.message);
            return;
        }

        setSaving(true);
        setError('');
        try {
            const response = await createEpmTag(userData?.token, userData?.selectedOrganization?.org_token, { name: formatted });
            toast.success(response?.message || 'Tag created successfully.');
            await onSaved();
        } catch (apiError) {
            const message = apiError?.message || 'Unable to create the tag.';
            setError(message);
            toast.error(message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <PrimaryModal title="Add New Tag" hideModal={onClose} loading={saving} widthClass="max-w-lg">
            <form className="p-6 space-y-4" onSubmit={handleSubmit}>
                <Input
                    id="epm-new-tag"
                    label="Tag"
                    type="text"
                    value={tag}
                    autoFocus
                    maxLength={EPM_LIMITS.TAG_NAME_MAX}
                    placeholder="e.g. cta-copy, a/b"
                    error={error}
                    showCharCount
                    onChange={(event) => {
                        setTag(event.target.value);
                        if (error) setError('');
                    }}
                />
                <div className="flex items-center justify-end gap-2 pt-2">
                    <Button variant="secondary" size="sm" type="button" disabled={saving} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" size="sm" type="submit" loading={saving} disabled={!tag.trim()}>
                        Save
                    </Button>
                </div>
            </form>
        </PrimaryModal>
    );
};

export default AddTagModal;
